import React from "react";

const GoogleOAuthLogin = () => {
  const CLIENT_ID = "394384083889-mt93eeee076o5s7aplqekdla4fgdjijf.apps.googleusercontent.com";

  // const REDIRECT_URI = "https://test.psychooncology.online/oauth/google/redirect"; // Must match the backend redirect URI
  const REDIRECT_URI = "https://api.psychooncology.online/oauth/callback"; 
  const AUTH_URL = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=https://www.googleapis.com/auth/calendar&access_type=offline`;

  const handleLogin = () => {
    window.location.href = AUTH_URL; // Redirect to Google's OAuth consent page
  };

  return (
    <div>
      <h1>Login with Google</h1>
      <button onClick={handleLogin}>Login with Google</button>
    </div>
  );
};

export default GoogleOAuthLogin;
